<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { on, off } from "view-design/src/utils/dom";
import { setMatchMedia } from "view-design/src/utils/assist";

import { mapMutations } from "vuex";

setMatchMedia();

export default {
  name: "app",
  methods: {
    ...mapMutations("admin/layout", ["setDevice"]),
    handleWindowResize() {
      this.handleMatchMedia();
    },
    handleMatchMedia() {
      const matchMedia = window.matchMedia;

      if (matchMedia("(max-width: 600px)").matches) {
        this.setDevice("Mobile");
      } else if (matchMedia("(max-width: 992px)").matches) {
        this.setDevice("Tablet");
      } else {
        this.setDevice("Desktop");
      }
    },
  },
  mounted() {
    on(window, "resize", this.handleWindowResize);
    this.handleMatchMedia();
  },
  beforeDestroy() {
    off(window, "resize", this.handleWindowResize);
  },
};
</script>
<style lang="scss">
.ivu-switch:focus {
  box-shadow: none !important;
}
.ivu-menu-light.ivu-menu-vertical {
  .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    background: #00d37f !important;
  }
  .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: #e4f7ed !important;
    color: #00b86f !important;
    opacity: 1 !important;
  }
}
.sider-left .menu-list .menu-item.active {
  background: #e4f7ed !important;
  color: #00b86f !important;
}
.ivu-btn-primary {
  background-color: #00d37f !important;
  border-color: #00d37f !important;
  &:hover {
    opacity: 0.8;
  }
  &[disabled="disabled"] {
    background-color: #f7f7f7 !important;
    border-color: #dcdee2 !important;
    &:hover {
      opacity: 1;
    }
  }
}
.ivu-page-item-active {
  border-color: #00b86f !important;
}
.ivu-page-item-active a {
  color: #00b86f !important;
}
.el-button--text {
  color: #00b86f !important;
}
.el-image-viewer__close {
  color: #ffffff;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-button--primary,
.ivu-switch-checked {
  background-color: #00d37f !important;
  border-color: #00d37f !important;
}
.el-button--primary.is-disabled {
  opacity: 0.8 !important;
}
.ivu-btn-ghost.ivu-btn-primary {
  color: #ffffff !important;
}
.ivu-radio-wrapper-checked.ivu-radio-border,
.ivu-radio-checked .ivu-radio-inner,
.ivu-input:hover {
  border-color: #00d37f !important;
}
.ivu-radio-inner:after {
  background-color: #00d37f !important;
}
</style>
